const contactData = {
  hero: {
    title: "Contact Us",
    subtitle: "Have questions about buying or selling? Our team is here to help.",
  },
  panel: {
    title: "Get in touch",
    subtitle:
      "We'd love to hear from you. Send us a message and we'll respond as soon as possible.",
    emailLabel: "Email Us",
    phoneLabel: "Call Us",
    socialLabel: "Follow our social media",
  },
  form: {
    title: "Send us a message",
    submitLabel: "Send Message",
    submittingLabel: "Sending...",
    fields: [
      {
        name: "name",
        label: "Your Name",
        type: "text",
        placeholder: "Enter your full name",
        required: true,
        layout: "half",
      },
      {
        name: "category",
        label: "Category",
        type: "select",
        placeholder: "Select category",
        required: true,
        layout: "half",
        options: [
          { value: "buy", label: "Buy a Car" },
          { value: "sell", label: "Sell a Car" },
          { value: "valuation", label: "Car Valuation" },
          { value: "finance", label: "Finance / EMI" },
          { value: "support", label: "General Support" },
        ],
      },
      {
        name: "phone",
        label: "Phone Number",
        type: "tel",
        placeholder: "Enter phone number",
        required: true,
        layout: "half",
      },
      {
        name: "email",
        label: "Email Address",
        type: "email",
        placeholder: "Enter email address",
        required: true,
        layout: "half",
      },
      {
        name: "subject",
        label: "Subject",
        type: "text",
        placeholder: "What is this about?",
        required: true,
        layout: "full",
      },
      {
        name: "message",
        label: "Message",
        type: "textarea",
        placeholder: "Write your message here...",
        required: true,
        layout: "full",
        rows: 5,
      },
    ],
    validation: {
      requiredMessage: "Please fill in all required fields",
      successTitle: "Message Sent",
      successMessage: "Thank you! We will get back to you shortly.",
      errorTitle: "Could not send",
      errorMessage: "Something went wrong. Please try again.",
    },
  },
  office: {
    name: "Head Office",
    address: "Madurai, Tamil Nadu, India",
  },
  email: "support@carsinfinite.com",
  phone: "+91 98765 43210",
  socials: {
    facebook: "#",
    twitter: "#",
    linkedin: "#",
    youtube: "#",
  },
  map: {
    location: "madurai",
  },
};

export default contactData;
